import {connect} from 'react-redux';
import React, {Component} from 'react';
import DatePicker from '../../components/partial/DatePicker/DatePicker';
import {toggleDatePickerOpenState, toggleDatePickerActiveState, datePickerEndDate, datePickerStartDate, datePickerDatesRange, fetchPostsByDate} from './../../actions';
import {browserHistory} from 'react-router';
import utils from '../../utils/utils';

class DatePickerController extends Component {
  render() {
    return (
      <DatePicker {...this.props}/>
    );
  }
}

function searchPosts(params) {
  utils.reportBi('335');

  browserHistory.push(`/release/notes/${params.tag}`);

  return fetchPostsByDate({
    startDate: utils.buildDateFormat(params.startDate),
    endDate: utils.buildDateFormat(params.endDate),
    tag: params.tag,
    baseURL: window.basePath,
    basename: window.relPath
  });
}

function mapStateToProps(state) {
  return {
    open: state.datepicker.open,
    active: state.datepicker.active,
    startDate: state.datepicker.startDate,
    endDate: state.datepicker.endDate,
    dateRange: state.datepicker.dateRange,
    tag: state.posts.tag,
    getDaysRange: utils.getDaysRange,
    searchPosts
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleDatePickerOpenState(params) {
      dispatch(toggleDatePickerOpenState(params));
    },
    toggleDatePickerActiveState(params) {
      dispatch(toggleDatePickerActiveState(params));
    },
    datePickerStartDate(params) {
      dispatch(datePickerStartDate(params));
    },
    datePickerEndDate(params) {
      dispatch(datePickerEndDate(params));
    },
    datePickerDatesRange(params) {
      dispatch(datePickerDatesRange(params));
    },
    fetchPostsByDate(params) {
      dispatch(searchPosts(params));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerController);



// WEBPACK FOOTER //
// ./containers/DatePicker/DatePicker.js